import { render, staticRenderFns } from "./UserNotificationsListItem.vue?vue&type=template&id=d23257ea&scoped=true&"
import script from "./UserNotificationsListItem.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsListItem.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsListItem.vue?vue&type=style&index=0&id=d23257ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23257ea",
  null
  
)

export default component.exports